import React from 'react';
import icons from '../../assets/icons/icons';
import color from '../../assets/colors';

const ContentPopup = (props: any) => {
  return (
    <div className="content-overlay">
      <div className="content-container">
        <div className="details-container">
          <div className="content popup-responsive" dangerouslySetInnerHTML={{ __html: props.data }} />
          <span className="content-close-icon" onClick={props.onCloseHandler}>
            {icons.close(color.$black, '')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ContentPopup;
